/**
 * Routes where we re-validate the current user's is_active status via GET /user.
 * Covers: home, model overview tabs (dashboard/blocks/dimensions/data), plan + builder.
 */
const IMPORTANT_AUTH_ROUTE_PATTERNS = [
  /^\/home\/?$/,
  /^\/model\/[^/]+\/(dashboard|blocks|dimensions|data)\/?$/,
  /^\/model\/[^/]+\/block\/[^/]+\/plan\/?$/,
];

const isImportantAuthRoute = (pathname: string): boolean =>
  IMPORTANT_AUTH_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));

export default isImportantAuthRoute;
